import * as v from 'valibot'

export type EnqueteFormType = {
  title: string
  questions: EnqueteFormQuestionType[]
  answeredChatMessage: EnqueteFormAnsweredChatMessageType | undefined
}

export type EnqueteFormAnsweredChatMessageType = {
  body: string
  selections: string[] | undefined
}

export type EnqueteFormQuestionType = {
  key: string
  guid: string | undefined
  questionText: string
  userVariableDefinitionGUID: string | undefined
  isAnswerRequired: boolean
}

export const validEnqueteFormSchema = v.object({
  title: v.pipe(v.string(), v.trim(), v.nonEmpty('必須です')),
  questions: v.pipe(
    v.array(
      v.object({
        guid: v.optional(v.string()),
        questionText: v.pipe(v.string(), v.trim(), v.nonEmpty('必須です')),
        userVariableDefinitionGUID: v.nonNullish(v.string(), '必須です'),
        isAnswerRequired: v.boolean(),
      })
    ),
    v.check(questions => {
      // 記録するカスタム項目 (userVariableDefinitionGUID) の重複チェック
      const guidSet = new Set<string>()
      for (const q of questions) {
        if (guidSet.has(q.userVariableDefinitionGUID)) {
          return false
        }
        guidSet.add(q.userVariableDefinitionGUID)
      }

      return true
    }, '記録するカスタム項目 が重複しています')
  ),
  answeredChatMessage: v.optional(
    v.object({
      body: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('メッセージを入力してください')
      ),
      selections: v.optional(
        v.pipe(
          v.array(
            v.pipe(v.string(), v.trim(), v.nonEmpty('選択肢の内容が空です'))
          ),
          v.minLength(2)
        )
      ),
    })
  ),
})

export type EnqueteFormErrors = v.FlatErrors<typeof validEnqueteFormSchema>

export type EnqueteFormErrorPath = keyof NonNullable<
  EnqueteFormErrors['nested']
>

export type EnqueteFormErrorManager = {
  get: (path: EnqueteFormErrorPath) => string | undefined
}
